import {createState as createGlobxState} from 'globx';
import {Subject}                         from 'rxjs';

import IInteractionPayload  from '../Analytics/Interactions/Interfaces/IInteractionPayload';
import NodeEnvironment      from '../Shared/Constants/NodeEnvironment';

import IPlayerState             from './Shared/Interfaces/IPlayerState';
import IPlayerStores            from './Shared/Interfaces/IPlayerStores';
import ISnapshot                from './Shared/Interfaces/ISnapshot';
import createCaptionsStore      from './Stores/Captions/createCaptionsStore';
import createConfigStore        from './Stores/Config/createConfigStore';
import createFrameStore         from './Stores/Frame/createFrameStore';
import createLocalStorageStore  from './Stores/LocalStorage/createLocalStorageStore';
import readLocalStorage         from './Stores/LocalStorage/Util/readLocalStorage';
import createMediaStore         from './Stores/Media/createMediaStore';
import createPlaybackStore      from './Stores/Playback/createPlaybackStore';
import createTimelineStore      from './Stores/Timeline/createTimelineStore';
import createVolumeStore        from './Stores/Volume/createVolumeStore';

/**
 * Creates the application state and all stores, returning a reference
 * to the state.
 *
 * Accepts an optional `initialSnapshot` as a parameter in order to
 * hydrate the state with initial set of values for testing.
 */

const createState = (
    interactions$: Subject<IInteractionPayload>,
    initialSnapshot?: ISnapshot
): IPlayerState => {
    const state: IPlayerState = createGlobxState<IPlayerStores, ISnapshot>({
        debug: process.env.NODE_ENV === NodeEnvironment.DEVELOPMENT
    });

    const localStorageContents = readLocalStorage();

    const {captions, config, frame, localStorage, media, playback, timeline, volume} = initialSnapshot || ({} as any);

    const initialLocalStorageSnapshot = Object.keys(localStorageContents).length > 0 ?
        {...localStorageContents, ...localStorage} :
        localStorage;

    createCaptionsStore(state, captions);
    createConfigStore(state, config);
    createFrameStore(state, interactions$, frame);
    createLocalStorageStore(state, initialLocalStorageSnapshot);
    createMediaStore(state, media);
    createPlaybackStore(state, interactions$, playback);
    createTimelineStore(state, timeline);
    createVolumeStore(state, interactions$, volume);

    return state;
};

export default createState;